// redux/appState.ts

import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlicer';
import systemConfigReducer from './systemConfigSlicer';
import loadingSlicer from './loadingSlicer';

const store = configureStore({
  reducer: {
    user: userReducer,
    loading: loadingSlicer,
    systemConfig: systemConfigReducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;